import React from 'react'
import { Link } from 'react-router-dom'
import './Layout.css'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout">
      <header className="layout-header">
        <h1>React SPA</h1>
        <nav>
          <Link to="/">Home</Link>
          <Link to="/api-demo">API Demo</Link>
          <Link to="/test">Test</Link>
        </nav>
      </header>
      <main className="layout-main">
        {children}
      </main>
      <footer className="layout-footer">
        <p>React SPA – build once, deploy many</p>
      </footer>
    </div>
  )
}

export default Layout